import request from '@/utils/request';
import Resource from '@/api/resource';
import JSONbig from 'json-bigint';

class ReportResource extends Resource {
  constructor() {
    super('/report/material');
  }

  // 获取素材报表列表
  getMaterialReportListApi(params) {
    return request({
      url: `${this.uri}`,
      method: 'get',
      params,
      transformResponse: (response) => {
        const is_huawei = params?.advertisers.includes('huawei');
        return is_huawei ? JSONbig({ storeAsString: true }).parse(response) : JSON.parse(response);
      },
    });
  }

  // 导出数据报表
  exportMaterialReportApi(params) {
    return request({
      url: `${this.uri}`,
      method: 'get',
      params,
      responseType: 'blob',
      headers: {
        'accept':	'text/csv',
      },
    });
  }

  /**
   * 录入素材费用接口
   * @param {FormData} data 数据结构
   */
  batchUploadCostApi(data) {
    return request({
      url: `${this.uri}/batchUploadCost`,
      method: 'post',
      data,
    });
  }
}

export { ReportResource as default };
